import md5 from 'md5';

import logger from 'portfolio-shared/util/logging';

export default function submit(data, dispatch, props) {
  const {
    createUser,
    initialize,
    isCreate,
    successMessage,
    updateUser,
    isToken,
  } = props;
  const {
    addUserToAllCatalogs,
    name,
    password,
    longName,
    email,
    notes,
    roleName,
    uuid,
    fromLDAP,
    ldapSourceDN,
  } = data;
  const user = {
    name,
    password: password ? md5(password) : password,
    longName,
    email,
    notes,
    uuid,
    isToken,
    fromLDAP,
    ldapSourceDN,
  };

  if (isCreate) {
    logger.debug('Submitting create user: ', user);
    createUser(user, addUserToAllCatalogs, roleName);
  } else {
    logger.debug('Submitting update user: ', user);
    updateUser(user, successMessage);
    delete user.password;
    initialize(user);
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/UsersPage/submitUser.js